/**
 * Define and Export Action Types
 */

export const WATCHLIST_CLEAR = 'WATCHLIST_CLEAR'
export const WATCHLIST_SET_ACTIVE_LIST = 'WATCHLIST_SET_ACTIVE_LIST'
export const WATCHLIST_SET_ACTIVE_VIEW = 'WATCHLIST_SET_ACTIVE_VIEW'
export const WATCHLIST_SET_ONDECK = 'WATCHLIST_SET_ONDECK'
export const WATCHLIST_SET_LOCAL_STATE = 'WATCHLIST_SET_LOCAL_STATE'
export const WATCHLIST_TOGGLE_ANALYSIS = 'WATCHLIST_TOGGLE_ANALYSIS'

export const WATCHLIST_CREATE_LIST_REQUEST = 'WATCHLIST_CREATE_LIST_REQUEST'
export const WATCHLIST_CREATE_LIST_RECEIVE = 'WATCHLIST_CREATE_LIST_RECEIVE'
export const WATCHLIST_CREATE_LIST_FAILURE = 'WATCHLIST_CREATE_LIST_FAILURE'

export const WATCHLIST_RENAME_LIST_REQUEST = 'WATCHLIST_RENAME_LIST_REQUEST'
export const WATCHLIST_RENAME_LIST_RECEIVE = 'WATCHLIST_RENAME_LIST_RECEIVE'
export const WATCHLIST_RENAME_LIST_FAILURE = 'WATCHLIST_RENAME_LIST_FAILURE'

export const WATCHLIST_ADD_TICKER_REQUEST = 'WATCHLIST_ADD_TICKER_REQUEST'
export const WATCHLIST_ADD_TICKER_RECEIVE = 'WATCHLIST_ADD_TICKER_RECEIVE'
export const WATCHLIST_ADD_TICKER_FAILURE = 'WATCHLIST_ADD_TICKER_FAILURE'
export const WATCHLIST_ADD_TICKERS_REQUEST = 'WATCHLIST_ADD_TICKERS_REQUEST'
export const WATCHLIST_ADD_TICKERS_RECEIVE = 'WATCHLIST_ADD_TICKERS_RECEIVE'
export const WATCHLIST_ADD_TICKERS_FAILURE = 'WATCHLIST_ADD_TICKERS_FAILURE'

export const WATCHLIST_REMOVE_TICKER_REQUEST = 'WATCHLIST_REMOVE_TICKER_REQUEST'
export const WATCHLIST_REMOVE_TICKER_RECEIVE = 'WATCHLIST_REMOVE_TICKER_RECEIVE'
export const WATCHLIST_REMOVE_TICKER_FAILURE = 'WATCHLIST_REMOVE_TICKER_FAILURE'
export const WATCHLIST_REMOVE_TICKERS_REQUEST = 'WATCHLIST_REMOVE_TICKERS_REQUEST'
export const WATCHLIST_REMOVE_TICKERS_RECEIVE = 'WATCHLIST_REMOVE_TICKERS_RECEIVE'
export const WATCHLIST_REMOVE_TICKERS_FAILURE = 'WATCHLIST_REMOVE_TICKERS_FAILURE'

export const WATCHLIST_DELETE_LIST_REQUEST = 'WATCHLIST_DELETE_LIST_REQUEST'
export const WATCHLIST_DELETE_LIST_RECEIVE = 'WATCHLIST_DELETE_LIST_RECEIVE'
export const WATCHLIST_DELETE_LIST_FAILURE = 'WATCHLIST_DELETE_LIST_FAILURE'

export const WATCHLIST_LOAD_REQUEST = 'WATCHLIST_LOAD_REQUEST'
export const WATCHLIST_LOAD_RECEIVE = 'WATCHLIST_LOAD_RECEIVE'
export const WATCHLIST_LOAD_FAILURE = 'WATCHLIST_LOAD_FAILURE'

export const WATCHLIST_REFRESH_REQUEST = 'WATCHLIST_REFRESH_REQUEST'
export const WATCHLIST_REFRESH_RECEIVE = 'WATCHLIST_REFRESH_RECEIVE'
export const WATCHLIST_REFRESH_FAILURE = 'WATCHLIST_REFRESH_FAILURE'

export const WATCHLIST_VALIDATE_TICKERS_REQUEST = 'WATCHLIST_VALIDATE_TICKERS_REQUEST'
export const WATCHLIST_VALIDATE_TICKERS_RECEIVE = 'WATCHLIST_VALIDATE_TICKERS_RECEIVE'
export const WATCHLIST_VALIDATE_TICKERS_REMOVE = 'WATCHLIST_VALIDATE_TICKERS_REMOVE'
export const WATCHLIST_VALIDATE_TICKERS_FAILURE = 'WATCHLIST_VALIDATE_TICKERS_FAILURE'

export const WATCHLIST_DOWNLOAD_REQUEST = 'WATCHLIST_DOWNLOAD_REQUEST'
export const WATCHLIST_DOWNLOAD_RECEIVE = 'WATCHLIST_DOWNLOAD_RECEIVE'
export const WATCHLIST_DOWNLOAD_FAILURE = 'WATCHLIST_DOWNLOAD_FAILURE'
